/**
 * Modal utility functions for managing body scroll lock and footer visibility
 */

/**
 * @returns {number}
 */
export const openModal = () => {
  const scrollY = window.scrollY;
  const count = parseInt(document.body.dataset.modalCount || '0', 10);
  
  if (count === 0) {
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('modal-open');
  }
  
  document.body.dataset.modalCount = String(count + 1);
  return scrollY;
};

/**
 * Closes a modal
 * @param {number} scrollY
 */
export const closeModal = (scrollY) => {
  const count = parseInt(document.body.dataset.modalCount || '0', 10);
  const newCount = Math.max(0, count - 1);
  
  document.body.dataset.modalCount = String(newCount);
  
  if (newCount === 0) {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    document.body.classList.remove('modal-open');
    
    if (typeof scrollY === 'number') {
      window.scrollTo(0, scrollY);
    }
  }
};

/**
 * React hook for modal scroll locking
 */
export const useModalLock = () => {
  return { openModal, closeModal };
};

